import React from 'react';
import { Button, Carousel, Container } from 'react-bootstrap';
import { BiLinkExternal } from "react-icons/bi";

import Particle from '../../Particle';
import Shop from "../../../Images/Project/Ontik/Shop.JPG";
import Details from "../../../Images/Project/Ontik/Detail.JPG";
import Cart from "../../../Images/Project/Ontik/cart.JPG";
import Admin from "../../../Images/Project/Ontik/admin.JPG";

const Ontik = () => {
    return (
        <Container fluid className="project-section">
            <Particle />
            <Container>
                <h1 className="project-heading">
                    Ontik <strong className="purple"> Shop </strong>
                </h1>
                <div className='mt-5 mb-5'>
                    <div className='container '>
                        <div className='row '>
                            <div className='col-lg-6 col-sm-12'>
                                <Carousel fade>

                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={Shop}
                                            alt="Second slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={Details}
                                            alt="Third slide"
                                        />
                                    </Carousel.Item>

                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={Admin}
                                            alt="First slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={Cart}
                                            alt="Fourth slide"
                                        />
                                    </Carousel.Item>
                                </Carousel>

                            </div>
                            <div className='col-lg-6 col-sm-12'>
                                <p className='fw-bold text-white'>This is a Full-Stack E-Commerce website.User can Select any Item and buy it. </p>

                                <p className='text-white'>
                                    <ul>
                                        <li>Users can purchase Item and see his/her product in the Cart. </li>
                                        <li>Customize Dashboard for User and Admin. </li>
                                        <li>Admin can delete, add, New Products</li>
                                        <li>Admin can add new tour plan</li>
                                        <li>Users can Register via Email and can login by using that Email.</li>
                                        <li>Users can pay for their booking using International Debit/Credit card(working on it).</li>
                                    </ul></p>
                                <p className='text-white'> Front-end technology: React js,Redux Toolkit, React Slick React Bootstrap, React Router(V6), Firebase Authentication</p>
                                <p className='text-white'> Back-end technology: Node js,Express js, MongoDB</p>
                                <Button href='https://github.com/nhnajmul17/Ontik-shop' style={{ marginRight: '3px' }} className='btn btn-info '>  <BiLinkExternal /> &nbsp;Client Side</Button>
                                <Button href='https://github.com/nhnajmul17/Ontik-shop-server' style={{ marginRight: '3px' }} className='btn btn-info  '>  <BiLinkExternal /> &nbsp;server Side</Button>
                                <Button href='https://teck-shop-01.web.app/' className='btn btn-info'>  <BiLinkExternal /> &nbsp;Live Site</Button>

                            </div>

                        </div>

                    </div>


                </div>


            </Container>
        </Container>

    );
};

export default Ontik;